import React from "react";
import { Button } from "react-bootstrap";
import WarningModal from "../WarningModal";
import FeePopupModal from "../FeePopupModal/FeePopupModal";

const FeeSummaryPopUp = ({
  showPopup,
  setShowpopup,
  handleConfirmClick,
  handleCancelClick,
}) => {
  return (
    <FeePopupModal show={showPopup}>
      <div className="popup-border">
        <h5 className="ml-15"> Attention Required.</h5>
        <div className="remove-text">
          <p>
            The fee run will commence immediately. <br />
            Would you like to proceed?
          </p>
          <Button
            className="popup-cancel-btn mr-4"
            variant="secondary"
            onClick={handleCancelClick}
          >
            cancel
          </Button>
          <Button className="popup-ok-btn" onClick={handleConfirmClick}>
            ok
          </Button>
        </div>
      </div>
    </FeePopupModal>
  );
};
export default FeeSummaryPopUp;
